<template>
  <div
    class="grid gap-4 text-primary-950 md:gap-x-8 xl:grid-cols-[max-content_1fr]"
  >
    <app-user-avatar
      :avatar-url="teacher.avatar_url"
      class="aspect-square w-[120px] !rounded-lg !rounded-br-[32%] xl:w-[270px]"
      :name="teacher.full_name"
      :size="270"
      tile
    />
    <div class="xl:pt-4">
      <h1>
        <span
          class="block font-title text-4xl/normal lg:text-5xl/normal"
          data-cy-teacher-name
          >{{ teacher.full_name }}</span
        >
        <span
          class="mr-2 mt-2 text-xl/normal lg:text-2xl/normal"
          data-cy-teacher-job
          >{{ teacher.description_short || teacher.job }}</span
        >

        <div class="mt-2">
          <teacher-companies-logos
            class="align-text-bottom"
            :companies="teacher.companies"
            :height="40"
          />
        </div>
      </h1>

      <ul
        v-if="teacher.pinned || teacher.tags.length > 0"
        class="mt-6 flex flex-wrap gap-2"
      >
        <li v-if="teacher.pinned">
          <teacher-pinned-chip />
        </li>
        <li
          v-for="tag in teacher.tags.slice(0, MAXIMUM_TAG_DISPLAYED)"
          :key="tag.id"
        >
          <tag-chip :tag="tag" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

const MAXIMUM_TAG_DISPLAYED = 4;

defineProps<{
  teacher: TeacherPageView;
}>();
</script>
